module.exports = __webpack_public_path__ + "img/major2.2bf7783f.png";